export const GET_PERMISSIONS = '@permissions/GET_PERMISSIONS'
export const STORE_PERMISSIONS = '@permissions/STORE_PERMISSIONS'
export const REMOVE_PERMISSIONS = '@permissions/REMOVE_PERMISSIONS'